export const OMAN_VAT_REGEX = /^OM11\d{8}$/;
export const OMAN_VAT_MESSAGE =
  "VAT number must start with 'OM11' and be exactly 12 characters long";

export const omanVatRule = (schema) =>
  schema.required('VAT is required').matches(OMAN_VAT_REGEX, OMAN_VAT_MESSAGE);
